const initialState = {
    booleanCreateModalIsOpen: false,
    booleanDeleteModalIsOpen: false,
    booleanDisplayQuestionModalIsOpen: false,
    QID: 'none',
    LID: 'none',
    CID: 'none',
    question: {},
    NumberOfQuestionsInsideQList: 0,
    booleanUseThisQList: false,
    booleanMakeNewQList: false,
    QListNumberArray: [],
    booleanAddFrontImageModalIsOpen: false,
    booleanAddBackImageModalIsOpen: false,
    FlashcardImageFront: 'none',
    FlashcardImageBack: 'none',
    FrontImageName: 'none',
    BackImageName: 'none',
    booleanQuestionCreated: false,
}



const createQuestionReducer = (state = initialState, action) => {

    
    switch (action.type) {

        case 'CHANGE_QUESTION_MODAL':
            return {
                ...state,
                booleanCreateModalIsOpen: action.booleanCreateModalIsOpen,
                booleanDeleteModalIsOpen: action.booleanDeleteModalIsOpen,
                QID: action.QID,
                LID: action.LID,
                CID: action.CID,
                question: {},
                booleanDisplayQuestionModalIsOpen: false,
                NumberOfQuestionsInsideQList: 0,
                booleanUseThisQList: false,
                booleanMakeNewQList: false,
                QListNumberArray: [],
                booleanAddFrontImageModalIsOpen: action.booleanAddFrontImageModalIsOpen,
                booleanAddBackImageModalIsOpen: action.booleanAddBackImageModalIsOpen,
                booleanQuestionCreated: action.booleanQuestionCreated,

            }

        case 'CHANGE_QUESTION_MODAL_WITH_FRONT_DELETED':
            return {
                ...state,
                booleanCreateModalIsOpen: action.booleanCreateModalIsOpen,
                booleanDeleteModalIsOpen: action.booleanDeleteModalIsOpen,
                QID: action.QID,
                LID: action.LID,
                CID: action.CID,
                question: {},
                booleanDisplayQuestionModalIsOpen: false,
                NumberOfQuestionsInsideQList: 0,
                booleanUseThisQList: false,
                booleanMakeNewQList: false,
                QListNumberArray: [],
                booleanAddFrontImageModalIsOpen: action.booleanAddFrontImageModalIsOpen,
                booleanAddBackImageModalIsOpen: action.booleanAddBackImageModalIsOpen,
                booleanQuestionCreated: action.booleanQuestionCreated,
                FrontImageName: 'none',
                FlashcardImageFront: 'none',

            }

        case 'CHANGE_QUESTION_MODAL_WITH_BACK_DELETED':
            return {
                ...state,
                booleanCreateModalIsOpen: action.booleanCreateModalIsOpen,
                booleanDeleteModalIsOpen: action.booleanDeleteModalIsOpen,
                QID: action.QID,
                LID: action.LID,
                CID: action.CID,
                question: {},
                booleanDisplayQuestionModalIsOpen: false,
                NumberOfQuestionsInsideQList: 0,
                booleanUseThisQList: false,
                booleanMakeNewQList: false,
                QListNumberArray: [],
                booleanAddFrontImageModalIsOpen: action.booleanAddFrontImageModalIsOpen,
                booleanAddBackImageModalIsOpen: action.booleanAddBackImageModalIsOpen,
                booleanQuestionCreated: action.booleanQuestionCreated,
                BackImageName: 'none',
                FlashcardImageBack: 'none',

            }

        case 'CHANGE_QUESTION_MODAL_WITH_BOTH_DELETED':
            return {
                ...state,
                booleanCreateModalIsOpen: action.booleanCreateModalIsOpen,
                booleanDeleteModalIsOpen: action.booleanDeleteModalIsOpen,
                QID: action.QID,
                LID: action.LID,
                CID: action.CID,
                question: {},
                booleanDisplayQuestionModalIsOpen: false,
                NumberOfQuestionsInsideQList: 0,
                booleanUseThisQList: false,
                booleanMakeNewQList: false,
                QListNumberArray: [],
                booleanAddFrontImageModalIsOpen: action.booleanAddFrontImageModalIsOpen,
                booleanAddBackImageModalIsOpen: action.booleanAddBackImageModalIsOpen,
                booleanQuestionCreated: action.booleanQuestionCreated,
                FrontImageName: 'none',
                FlashcardImageFront: 'none',
                BackImageName: 'none',
                FlashcardImageBack: 'none',
            }

        case 'DISPLAY_QUESTION_MODAL': 
            return {
                ...state,
                booleanCreateModalIsOpen: action.booleanCreateModalIsOpen,
                booleanDeleteModalIsOpen: action.booleanDeleteModalIsOpen,
                booleanDisplayQuestionModalIsOpen: action.booleanDisplayQuestionModalIsOpen,
                QID: action.QID,
                LID: action.LID,
                CID: action.CID,
                NumberOfQuestionsInsideQList: 0,
                booleanUseThisQList: false,
                booleanMakeNewQList: false,
                QListNumberArray: [],
                question: action.question,
            }

        case 'ADD_FRONT_IMAGE':

        return{
            ...state,
            FlashcardImageFront: action.FlashcardImageFront,
        }

        case 'ADD_FRONT_IMAGE_NAME':

        return{
            ...state,
            FrontImageName: action.FrontImageName,
        }

        case 'ADD_BACK_IMAGE_NAME':

        return{
            ...state,
            BackImageName: action.BackImageName,
        }

        case 'ADD_BACK_IMAGE':

        return{
            ...state,
            FlashcardImageBack: action.FlashcardImageBack,
        }

        case 'CREATE_NEW_QUESTION':

        return {
            state,
        }

        case 'CREATE_NEW_QUESTION_ERROR':

            return{
                state,
            }

        case 'NARROW_QLIST_FOR_QUESTION':

            return{
                ...state,
                booleanCreateModalIsOpen: false,
                booleanDeleteModalIsOpen: false,
                booleanDisplayQuestionModalIsOpen: false,
                QID: 'none',
                LID: 'none',
                CID: 'none',
                question: {},
                NumberOfQuestionsInsideQList: action.NumberOfQuestionsInsideQList,
                booleanUseThisQList: action.booleanUseThisQList,
                booleanMakeNewQList: action.booleanMakeNewQList,
                QListNumberArray: action.QListNumberArray,
            }

        default:

            return state;
            
    }
    
}

//This information gets sent over to the "rootReducer" and stored on a "course" state.
export default createQuestionReducer
